import {ProtocolCommand} from '../../../service-model/protocol-command.interface';
import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-protocol-namespace.const';

export class CloseManualPosition implements ProtocolCommand {
  constructor(public positionId: string) {}

  guiToken: string;

  getOperationName(): string {
    return `${SHELL_PROTOCOL_OPERATIONS_NS}.CloseManualPosition`;
  }
}
